import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_properties_portfolio = _resolveComponent("properties-portfolio")!
  const _component_organization_about = _resolveComponent("organization-about")!
  const _component_testimonials_carousel = _resolveComponent("testimonials-carousel")!
  const _component_contact_form = _resolveComponent("contact-form")!
  const _component_page_layout = _resolveComponent("page-layout")!

  return (_openBlock(), _createBlock(_component_page_layout, {
    title: _ctx.organization ? _ctx.organization.name : '',
    text: _ctx.organization ? _ctx.organization.tagline: '',
    "button-text": "Find Housing",
    media: _ctx.media,
    socials: _ctx.socials,
    loaded: _ctx.organizationLoaded,
    onAction: _ctx.scrollToPortfolio
  }, {
    default: _withCtx(() => [
      (_ctx.organization)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.getBlockVisibility('discover-you-new-home') || _ctx.getBlockVisibility('featured-locations'))
              ? (_openBlock(), _createBlock(_component_properties_portfolio, {
                  key: 0,
                  id: "properties",
                  "blocks-visibility": {
          'discover-you-new-home': _ctx.getBlockVisibility('discover-you-new-home'),
          'featured-locations': _ctx.getBlockVisibility('featured-locations')
        }
                }, null, 8, ["blocks-visibility"]))
              : _createCommentVNode("", true),
            (_ctx.getBlockVisibility('about'))
              ? (_openBlock(), _createBlock(_component_organization_about, {
                  key: 1,
                  title: _ctx.organization.name,
                  text: _ctx.organization.description
                }, null, 8, ["title", "text"]))
              : _createCommentVNode("", true),
            (_ctx.getBlockVisibility('what-people-say-about-us'))
              ? (_openBlock(), _createBlock(_component_testimonials_carousel, {
                  key: 2,
                  "organization-id": `${_ctx.organization.id}`
                }, null, 8, ["organization-id"]))
              : _createCommentVNode("", true),
            (_ctx.organization.id && _ctx.getBlockVisibility('have-a-question?-please-ask-us'))
              ? (_openBlock(), _createBlock(_component_contact_form, {
                  key: 3,
                  "contact-data": _ctx.organization
                }, null, 8, ["contact-data"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "text", "media", "socials", "loaded", "onAction"]))
}